<div class="container-fluid">
  <form (submit)="handleSearchSubmit($event)">
    <div class="form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <div class="input-group">
            <wl-events-context-search-input
              (searchParamsChange)="searchChanged($event)"
              defaultSearchDateStart="1/1/2010"
              placeholderText="{{ 'events.shared.left-nav.search-placeholder' | translate | titlecase }}"
            ></wl-events-context-search-input>
            <span class="input-group-btn">
              <button pButton type="button" class="btn btn-default" [disabled]="isSearching" [icon]="!isSearching ? 'pi pi-search' : ''">
                <wl-busy [show]="isSearching"></wl-busy>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </form>
  <ul class="list-unstyled">
    <li class="wc-left-nav-event wc-truncate-ellipsis" *ngFor="let event of searchResults.Result">
      <a [routerLink]="['/event/', event.EventId]" [title]="event.EventName"
        >{{ event.EventName }} ({{ event.StartDate | date: 'MM/dd/yyyy' }})</a
      >
    </li>
  </ul>
  <h4 *ngIf="recentlyViewed.Result.length">Recently Viewed</h4>
  <ul class="list-unstyled">
    <li class="wc-left-nav-event wc-truncate-ellipsis" *ngFor="let event of recentlyViewed.Result">
      <a [routerLink]="['/event/', event.EventId]" [title]="event.EventName"
        >{{ event.EventName }} ({{ event.StartDate | date: 'MM/dd/yyyy' }})</a
      >
    </li>
  </ul>
  <h4 *ngIf="upcomingEvents.Result.length">Upcoming Events</h4>
  <ul class="list-unstyled">
    <li class="wc-left-nav-event wc-truncate-ellipsis" *ngFor="let event of upcomingEvents.Result">
      <a [routerLink]="['/event/', event.EventId]" [title]="event.EventName"
        >{{ event.EventName }} ({{ event.StartDate | date: 'MM/dd/yyyy' }})</a
      >
    </li>
  </ul>
</div>
